import React, { useEffect, useState } from "react";
import { loadStripe } from "@stripe/stripe-js";

const stripePromise = loadStripe("pk_test_51Rq65BGgIqJ5Tz6mize4UsxdCwNuA8LkXtvGAxaGoxkSZnz3S5hmFsOhbnwc0swsCg5yRbtvmDD3tLrNCpJewkXh005YJKZfaX");

const PaymentPage = () => {
  const [stripe, setStripe] = useState(null);
  const [card, setCard] = useState(null);

  // ✅ INIT STRIPE
useEffect(() => {
  if (!window.location.pathname.includes("/payment")) return;

  const initStripe = async () => {
    const stripeInstance = await stripePromise;

    const numberEl = document.getElementById("card-number");
    const expiryEl = document.getElementById("card-expiry");
    const cvcEl = document.getElementById("card-cvc");

    if (!numberEl || !expiryEl || !cvcEl) return;
    if (numberEl.hasChildNodes()) return;

    const elements = stripeInstance.elements();

    const style = {
          base: {
            fontSize: "14px",
            fontWeight: "600",
            fontFamily: '"Outfit", system-ui, -apple-system, Segoe UI, Roboto, sans-serif',
            color: "#131E29",
            fontSmoothing: "antialiased",
            "::placeholder": {
              color: "#888",
              fontFamily: '"Outfit", sans-serif',
            },
          },
          invalid: {
            color: "#dc3545",
          },
        };

    const cardNumber = elements.create("cardNumber", {
          style,
          placeholder: ""
        });

        const cardExpiry = elements.create("cardExpiry", {
          style,
          placeholder: ""
        });

        const cardCvc = elements.create("cardCvc", {
          style,
          placeholder: ""
        });

    cardNumber.mount(numberEl);
    cardExpiry.mount(expiryEl);
    cardCvc.mount(cvcEl);

    // ✅ FIX: Handle UI properly
    const handleStripeUI = (element, container) => {
      element.on("focus", () => {
        container.classList.add("stripe-focus");
        container.classList.add("has-focus"); // ✅ ADD THIS
      });

      element.on("blur", () => {
        container.classList.remove("stripe-focus");
        container.classList.remove("has-focus"); // ✅ ADD THIS
      });

      element.on("change", (event) => {
        if (event.empty) {
          container.classList.remove("has-value");
        } else {
          container.classList.add("has-value");
        }
      });
    };
    const inputs = document.querySelectorAll(".custom-floating input");

    inputs.forEach((input) => {
      const wrapper = input.closest(".custom-floating");

      const updateState = () => {
        if (input.value.trim() !== "") {
          wrapper.classList.add("has-value");
        } else {
          wrapper.classList.remove("has-value");
        }
      };

      input.addEventListener("input", updateState);
      input.addEventListener("blur", updateState);
      input.addEventListener("focus", () => {
        wrapper.classList.add("stripe-focus"); // reuse style
      });
    });
    const numberWrap = numberEl.closest(".custom-floating");
    const expiryWrap = expiryEl.closest(".custom-floating");
    const cvcWrap = cvcEl.closest(".custom-floating");

    handleStripeUI(cardNumber, numberWrap);
    handleStripeUI(cardExpiry, expiryWrap);
    handleStripeUI(cardCvc, cvcWrap);

    // ✅ Button enable logic
    let n = false, e = false, c = false;

    const updateBtn = () => {
      const btn = document.getElementById("pay-btn");
      if (btn) btn.disabled = !(n && e && c);
    };

    cardNumber.on("change", ev => { n = ev.complete; updateBtn(); });
    cardExpiry.on("change", ev => { e = ev.complete; updateBtn(); });
    cardCvc.on("change", ev => { c = ev.complete; updateBtn(); });

    setStripe(stripeInstance);
    setCard({ cardNumber });
  };

  setTimeout(initStripe, 200);
}, []);

  // ✅ PAYMENT SUBMIT
  useEffect(() => {
    if (!window.location.pathname.includes("/payment")) return;

    const attach = () => {
      const form = document.getElementById("payment-form");
      if (!form) return setTimeout(attach, 200);

      const submit = async (e) => {
        e.preventDefault();

        if (!stripe || !card) return;

        const loanPk = document.getElementById("loan-pk")?.value;
        const csrf = document.querySelector('[name=csrfmiddlewaretoken]')?.value;

        const name = document.getElementById("cardholder-name")?.value;
        const email = document.getElementById("cardholder-email")?.value;
        const address = document.getElementById("cardholder-address")?.value;

        const btn = document.getElementById("pay-btn");

        try {
          if (btn) btn.disabled = true;
          if (window.App && typeof window.App.showPageLoader === "function") {
            window.App.showPageLoader({ animate: false });
          }

          const res = await fetch("/create-payment-intent/", {
            method: "POST",
            credentials: "same-origin",
            headers: {
              "Content-Type": "application/json",
              "X-CSRFToken": csrf,
            },
            body: JSON.stringify({
              cardholder_name: name,
              cardholder_email: email,
              cardholder_address: address,
              loan_pk: loanPk,
            }),
          });

          const data = await res.json();
          if (!res.ok) throw new Error();

          const result = await stripe.confirmCardPayment(data.clientSecret, {
            payment_method: {
              card: card.cardNumber,
              billing_details: {
                name,
                email,
                address: { line1: address },
              },
            },
          });

          if (result.paymentIntent?.status === "succeeded") {
            window.location.href = `/confirm-payment/?loan_pk=${loanPk}`;
          } else {
            if (window.App && typeof window.App.hidePageLoader === "function") {
              window.App.hidePageLoader(true);
            }
            if (btn) btn.disabled = false;
          }

        } catch {
          if (window.App && typeof window.App.hidePageLoader === "function") {
            window.App.hidePageLoader(true);
          }
          if (btn) btn.disabled = false;
        }
      };

      form.addEventListener("submit", submit);
      return () => form.removeEventListener("submit", submit);
    };

    const cleanup = attach();
    return cleanup;

  }, [stripe, card]);

   useEffect(() => {
      if (!window.location.pathname.includes("/payment")) return;

      const loadGoogle = () => {
        if (window.google && window.google.maps) {
          initAuto();
          return;
        }

        const script = document.createElement("script");
        script.src =
          "https://maps.googleapis.com/maps/api/js?key=AIzaSyAVBbTxntcmpcJNC56NJPgESFQpM2H88iI&libraries=places";
        script.async = true;
        script.defer = true;
        script.onload = initAuto;

        document.head.appendChild(script);
      };

      const initAuto = () => {
        const input = document.getElementById("cardholder-address");
        if (!input || !window.google) return;

        const autocomplete = new window.google.maps.places.Autocomplete(input, {
          types: ["address"],
          componentRestrictions: { country: "us" }, // change if needed
        });

        autocomplete.addListener("place_changed", () => {
          const place = autocomplete.getPlace();
          if (place?.formatted_address) {
            input.value = place.formatted_address;
          }
        });
      };

      loadGoogle();
    }, []);

     useEffect(() => {

    const el = document.getElementById("redirect-data");

        if (!el) return;

        const redirectUrl = el.dataset.url;

        if (redirectUrl) {
          setTimeout(() => {
            window.location.href = redirectUrl;
          }, 2000);
        }

  }, []);

  return null;
};

export default PaymentPage;